const url = {
  baseUrl: window._env_.REACT_APP_BE_URL
};

export default url;